import { TField } from '@r1-frontend/ui-react/organisms/Forms/NamePhoneForm';
import { IAction } from '@r1-frontend/shared/types/Redux';

import { BP42Action } from '~/src/packages/bp42/constants/actions';

const fillPhone = ({ value, isValid }: Omit<TField, 'clearInput'>): IAction<BP42Action.FillPhone, { value: string, isValid: boolean }> => ({
    type: BP42Action.FillPhone,
    payload: {
        value,
        isValid,
    },
});

export default fillPhone;
